import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=60b56c14"
import script from "./Goals.vue?vue&type=script&lang=js"
export * from "./Goals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b56c14')) {
      api.createRecord('60b56c14', component.options)
    } else {
      api.reload('60b56c14', component.options)
    }
    module.hot.accept("./Goals.vue?vue&type=template&id=60b56c14", function () {
      api.rerender('60b56c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Goals.vue"
export default component.exports